import { render, staticRenderFns } from "./SuperAdminHomeView.vue?vue&type=template&id=1f5eac0c&"
import script from "./SuperAdminHomeView.vue?vue&type=script&lang=js&"
export * from "./SuperAdminHomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports